import { render, staticRenderFns } from "./AverageDurationPage.vue?vue&type=template&id=4889edbd&scoped=true&"
import script from "./AverageDurationPage.vue?vue&type=script&lang=js&"
export * from "./AverageDurationPage.vue?vue&type=script&lang=js&"
import style0 from "./AverageDurationPage.vue?vue&type=style&index=0&id=4889edbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889edbd",
  null
  
)

export default component.exports